module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc8-1c7e0bf8ba64cf4b1942c4a0f3a26bd4.jpg";